export default {
  // 支付列表
  query_getPayTaskList: {
    type: "formDataPost"
  },
  query_getPayTaskListByPage: {
    type: "post"
  },
  query_getPayTaskAmount: {
    type: "post"
  },
  // 拒绝支付
  pay_refusePay: {
    type: "formDataPost"
  },
  // 支付记录
  query_getPayLogListByPayId: {
    type: "formDataPost"
  },
  // 刷新状态
  pay_refreshPayTaskByPayId: {
    type: "formDataPost"
  },
  // 支付
  pay_exePay: {
    type: "post"
  },
  // 获取支付任务详情（支付回函）
  pay_getPayTaskInfoVo: {
    type: "post"
  },
  // 支付任务退票
  pay_backTicketPayTask: {
    type: "post"
  },
  // 获取支付通道
  merchant_payVendor_selectPayVendorByUser: {
    type: "post"
  },
  // 批量支付
  pay_batchPay: {
    type: "post"
  },
  // 导出
  export_exportPayTask: {
    type: "download"
  },
  // 批量拒绝
  pay_batchRefusePay: {
    type: "post"
  },
  // 批量刷新
  pay_batchRefreshPayTask: {
    type: "post"
  }
};



// WEBPACK FOOTER //
// ./src/service/modules/dataList.js